import type { AnalyticsEventData } from '../types';
import { isAnalyticsHost } from '../hosts';
import { sanitizeEventData, sanitizeEventName } from '../sanitize';

export const GA_MEASUREMENT_ID = 'G-5LP7ZFJS5P';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (
      command: 'event' | 'config' | 'js',
      targetId: string | Date,
      params?: Record<string, unknown>
    ) => void;
  }
}

/** -- Forward custom events to Google Analytics (gtag). */
export function trackGoogleEvent(
  event: string,
  data?: AnalyticsEventData
): void {
  if (!isAnalyticsHost()) return;
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return;

  const name = sanitizeEventName(event);
  const payload = sanitizeEventData(data);
  gtag('event', name, payload ?? {});
}
